export const BARE_ITEM = 'Bare Item';
